import moment from 'moment';
import { isNil } from 'lodash';
import { escapeHtml } from 'utils/security';

export function createStopPopup(data, translations) {
  const {
    arr_time: arrival,
    dep_time: departure,
    jobTags = [],
    address,
    labels,
    territory,
    skills,
    categories,
    priority,
    load,
  } = data;

  const {
    map: {
      arrivalJobMarkerTrans,
      departureJobMarkerTrans,
      territoryMarkerTrans,
      skillsMarkerTrans,
      categories: categoriesTrans,
      priorityTrans,
      load: loadTrans,
    },
  } = translations;

  const addressLabel = address ? `${escapeHtml(address)}<br/>` : '';
  const labelsLabel = labels ? labels.map(escapeHtml).join('<br/>') : '';
  const title = `<div style="color: #000; font-weight: bold; margin-bottom: 0.5rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${addressLabel}${labelsLabel}</div>`;

  const filteredTags = jobTags.filter((tag) => !isNil(tag));
  const tagsRow =
    filteredTags.length > 0
      ? `<tr><td>Tags:</td><td>${filteredTags.map(escapeHtml).join(', ')}</td></tr>`
      : '';

  const arrivalRow = arrival
    ? `<tr><td>${arrivalJobMarkerTrans}:</td><td>${moment(arrival).format('lll')}</td></tr>`
    : '';

  const departureRow = departure
    ? `<tr><td>${departureJobMarkerTrans}:</td><td>${moment(departure).format('lll')}</td></tr>`
    : '';

  const territoryRow = territory
    ? `<tr><td>${territoryMarkerTrans}:</td><td>${escapeHtml(territory.name)}</td></tr>`
    : '';

  const skillsRow =
    skills && skills.length > 0
      ? `<tr><td>${skillsMarkerTrans}:</td><td>${skills.map(escapeHtml).join(', ')}</td></tr>`
      : '';

  const categoriesRow =
    categories && categories.length > 0
      ? `<tr><td>${categoriesTrans}:</td><td>${categories.map(escapeHtml).join(', ')}</td></tr>`
      : '';

  const priorityRow =
    priority && priority.length > 0
      ? `<tr><td>${priorityTrans}:</td><td>${priority.map(escapeHtml).join(', ')}</td></tr>`
      : '';

  const loadRow =
    load && load.length > 0
      ? `<tr><td>${loadTrans}:</td><td>${load.map(escapeHtml).join(', ')}</td></tr>`
      : '';

  return `${title}
    <table>
      ${tagsRow}
      ${arrivalRow}
      ${departureRow}
      ${territoryRow}
      ${skillsRow}
      ${categoriesRow}
      ${priorityRow}
      ${loadRow}
    </table>`;
}
